import { useState, useEffect } from 'react';
import { environment } from '../components/Services/environment';

const endpoint = environment.serverUrl;

// Cache to store scope check results (persists across component re-renders)
const scopeCache = new Map();
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

export const useFeatureScopes = (storeUrl) => {
  const [scopes, setScopes] = useState({
    customer: { needsUpdate: false, chargeAlert: false },
    collection: { needsUpdate: false, chargeAlert: false },
    page: { needsUpdate: false, chargeAlert: false },
    metaobject: { needsUpdate: false, chargeAlert: false },
    order: { needsUpdate: false, chargeAlert: false },
    translation: { needsUpdate: false, chargeAlert: false },
    menu: { needsUpdate: false, chargeAlert: false }
  });

  useEffect(() => {
    if (!storeUrl) return;

    // Check cache first
    const cacheKey = `scopes_${storeUrl}`;
    const cached = scopeCache.get(cacheKey);
    
    if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
      console.log('Using cached scope data');
      setScopes(cached.data);
      return;
    }

    checkAllScopes();
  }, [storeUrl]);

  const checkAllScopes = async () => {
    const features = ['customer', 'collection', 'page', 'metaobject', 'order', 'translation', 'menu'];
    
    // Execute all scope checks in parallel instead of sequentially
    await Promise.all(features.map(feature => checkFeatureScope(feature)));
    
    // Cache the results
    const cacheKey = `scopes_${storeUrl}`;
    scopeCache.set(cacheKey, {
      data: scopes,
      timestamp: Date.now()
    });
  };

  const checkFeatureScope = async (type) => {
    try {
      const response = await fetch(
        `${endpoint}/api/Store/scope-check?storeUrl=${storeUrl}&type=${type}`
      );
      const data = await response.json();

      if (data.status === true && data.type === "scope") {
        setScopes(prev => ({
          ...prev,
          [type]: { ...prev[type], needsUpdate: true }
        }));
      }
    } catch (error) {
      console.error(`Error checking ${type} scope:`, error);
    }
  };

  return scopes;
};
